// extracted by mini-css-extract-plugin
export default {"modal":"_15378492","close":"_a7b0b44f","closeIcon":"_a3d9c544"};